import {
  fsL,
  fsXS,
  fwMediumBold,
} from '@aboutyou/legacy-shared/src/ui/constants/typography'
import { exists } from '@aboutyou/legacy-shared/src/utils/exists'
import {
  RecoSectionContent,
  TrackingPageTypeWithId,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk'
import PromotionLink from 'components/PromotionLink'
import { getImageUrl } from 'helpers/image'
import { ElementTrackingContextProvider } from 'helpers/tracking/ElementTrackingContext'
import { RecoGridSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import { PromotionImpression } from 'helpers/tracking/trackerComponents/ElementTracker'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import { usePremiumPageStore } from 'store/context'
import Outfit from 'store/entities/Outfit/Outfit.store'
import styled from 'styled-components'
import { complementaryColor } from 'uiComponents/constants/colors'
import ImageTile from './ImageTile'

const OutfitRow = styled.div`
  display: flex;
  margin-top: 80px;
`
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${complementaryColor};
`

const Title = styled.div`
  text-align: center;
  font-size: ${fsL}px;
  ${fwMediumBold}
`

const Subtitle = styled.div`
  text-align: center;
  font-size: ${fsXS}px;
  ${fwMediumBold}
`

const StyledLink = styled(PromotionLink)`
  width: 100%;
  height: 100%;
`

const OUTFIT_POSITIONS_START = 0
const OUTFIT_POSITIONS_END = 3

const PremiumOutfits: FC = () => {
  const service = useService()
  const outfitIds = usePremiumPageStore(store => store.premiumOutfitIds)

  const outfits = outfitIds
    .slice(OUTFIT_POSITIONS_START, OUTFIT_POSITIONS_END)
    .map(id => {
      const outfit = service.outfits.getById(id)
      return outfit
    })
    .filter(exists)

  if (outfits.length === 0) {
    return null
  }
  return (
    <RecoGridSectionTrackingContextProvider
      headline={'Premium Outfits'}
      recoType={RecoSectionContent.outfitRecommendationCategory}
    >
      <OutfitRow>
        {outfits.map(outfit => {
          return <TrackedOutfitTile key={outfit.id} outfit={outfit} />
        })}
      </OutfitRow>
    </RecoGridSectionTrackingContextProvider>
  )
}

export default PremiumOutfits

const TrackedOutfitTile: FC<{ outfit: Outfit }> = ({ outfit }) => {
  const service = useService()
  const idol = service.outfits.getIdolById(outfit.idolId)
  const imageUrl = getImageUrl(outfit.hotspotImageHash, {
    trim: false,
    width: 600,
    height: 800,
    bg: 'f2f2f2',
  })

  if (!imageUrl) {
    return null
  }
  return (
    <ElementTrackingContextProvider>
      <PromotionImpression<HTMLDivElement>
        type={TrackingPageTypeWithId.ODP}
        id={outfit.id}
        name={outfit.title}
        url={outfit.url}
        source={TrackingPromotionCreative.OutfitReco}
        useIdForDestination
      >
        {({ ref, onClickCapture }) => (
          <StyledLink onClickCapture={onClickCapture} to={outfit.url}>
            <ImageTile key={outfit.id} imageUrl={imageUrl}>
              <TitleWrapper ref={ref} data-testid="OutfitTile">
                <Title>{outfit.title}</Title>
                {idol && <Subtitle>{idol.name}</Subtitle>}
              </TitleWrapper>
            </ImageTile>
          </StyledLink>
        )}
      </PromotionImpression>
    </ElementTrackingContextProvider>
  )
}
